export class TimeZoneDTO{
    public timeZoneId!: string;
    public timeZoneName!: string;
}